/**
 * A channel's photo when we have one (a data-uri jpeg — the CSP allows img-src data:
 * for exactly this), else the first letter of its title. Never empty space: the fallback
 * keeps rows aligned whether Telegram gave us a picture or not.
 */
export function ChannelAvatar({ src, title, size }: { src: string | null; title: string; size?: "sm" }) {
  // M26b — the compact private-channel rows use the small variant.
  const dims = size === "sm" ? "h-6 w-6" : "h-8 w-8";
  if (src) {
    return <img src={src} alt="" className={`${dims} shrink-0 rounded-full object-cover`} />;
  }
  const letter = (title.trim()[0] ?? "#").toUpperCase();
  return (
    <div
      className={`flex ${dims} shrink-0 items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground`}
    >
      {letter}
    </div>
  );
}
